import React from 'react'
interface IProps {}

const CardTitle: React.FC<IProps> = ({children}) => {
  return <div className="card-subtitle px-2">{children}</div>
}

export default CardTitle
